import React, { useState } from 'react'
import { Button, Form, InputNumber, Row } from 'antd'

import styles from './index.module.less'

interface TotalLicensesProps {
	initialTotal: number
	onSave: (total: number) => void
	isDisabled: boolean
}
const TotalLicenses: React.VFC<TotalLicensesProps> = ({ initialTotal, onSave, isDisabled }) => {
	const [total, setTotal] = useState<number>(initialTotal)

	const save = () => {
		onSave(total)
	}

	const reset = () => {
		setTotal(initialTotal)
	}

	return (
		<Row>
			<Form layout='inline'>
				<Form.Item label='Licenses:'>
					<InputNumber value={total} onChange={setTotal} disabled={isDisabled}/>
				</Form.Item>
				{initialTotal !== total && (
					<Form.Item>
						<Button className={styles.totalLicensesButton} onClick={reset}>
							Reset
						</Button>
						<Button className={styles.totalLicensesButton} type='primary' onClick={save}>
							Save
						</Button>
					</Form.Item>
				)}
			</Form>
		</Row>
	)
}

export default TotalLicenses
